import useTheme from '@mui/material/styles/useTheme'

import { IProgressWidgetColors } from '@user/components/Opportunities/AddOpportunityPage/AddOpportunityForm/FormComponents/OpportunityStageMeter/ProgressWidget/typings'

/**
 * Computes the progress-widget colours and example rows shown on a card.
 *
 * Takes the theme flag as an argument rather than reading it from the store so
 * the hook stays a pure derivation of its inputs; the card owns the theme
 * wiring.
 *
 * @param isTidalThemeActive Whether the Tidal theme is active.
 */
export function useData(isTidalThemeActive: boolean) {
  const theme = useTheme()

  const colors: IProgressWidgetColors = {
    completeColors: {
      backgroundColor: isTidalThemeActive
        ? theme.palette.secondary.main
        : '#19305a',
      backgroundColorHover: isTidalThemeActive
        ? theme.palette.secondary.light
        : '#122240',
      textColor: isTidalThemeActive
        ? theme.palette.text.primary
        : theme.palette.common.white,
      textColorHover: isTidalThemeActive
        ? theme.palette.text.primary
        : theme.palette.common.white,
      strokeColor: '#19305a',
      strokeColorHover: '#122240',
    },
    incompleteColors: {
      backgroundColor: isTidalThemeActive ? '#F5F5F5' : '#ebeff3',
      backgroundColorHover: '#f7f7f7',
      textColor: isTidalThemeActive ? theme.palette.text.primary : '#19305a',
      textColorHover: isTidalThemeActive
        ? theme.palette.text.primary
        : '#122240',
      strokeColor: '#375ba3',
      strokeColorHover: '#375ba3',
    },
  }

  const items = [
    {
      isComplete: true,
      text: 'Schedule inspection',
      value: 1,
      id: 1,
    },
    {
      isComplete: false,
      text: 'Follow-up three',
      value: 2,
      id: 2,
    },
    {
      isComplete: false,
      text: 'Close',
      value: 3,
      id: 3,
    },
  ]

  return {
    colors,
    isTidalEnabled: isTidalThemeActive,
    items,
  }
}
